import { DataProvider, GetListParams } from 'react-admin';

import { httpClient } from '../httpClient';
import { GetUserResult } from '../types';

const transformData = (user: GetUserResult) => {
  return {
    ...user,
    isBanned: !!user.dateBannedTo,
  };
};

const fetchUsersList = async (params: GetListParams) => {
  const body = JSON.stringify(params);

  const usersList = await httpClient('/admin/user/search', {
    method: 'POST',
    body,
  });

  return {
    data: usersList.json.data.map(transformData),
    total: usersList.json.meta.total,
  };
};

// @ts-expect-error not yet all functions
export const usersDataProvider: DataProvider = {
  getList: async (_, params) => {
    return await fetchUsersList(params);
  },

  getMany: async () => {
    const { json } = await httpClient(`/admin/users/`, {
      method: 'GET',
    });

    return {
      data: json,
    };
  },

  getOne: async (_, params) => {
    const { json } = await httpClient(`/admin/users/${params.id}`, {
      method: 'GET',
    });

    return {
      data: transformData(json) as any,
    };
  },

  update: async (_, params) => {
    const { method, ...data } = params.data;

    await httpClient(`/admin/user/${params.id}/${method}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...params,
    });

    return {
      data: { id: params.id } as any,
    };
  },

  deleteMany: async (resource, params) => {
    return await Promise.all(
      params.ids.map((value) =>
        httpClient(`/admin/user/${value}`, {
          method: 'DELETE',
          ...params,
        }),
      ),
    ).then(() => ({ data: [] }));
  },
};
